import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {MultiImageChartConfigurations, MultiImageItem} from './multi.image.chart.configurations';
import {KlaHttpService} from '../../tools/services/kla.http.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-multi-image-chart',
  templateUrl: './multi-image-chart.component.html',
  styleUrls: ['./multi-image-chart.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class MultiImageChartComponent implements OnInit, OnChanges {

  @Input()
  public config: any;
  public totalValue = 0;
  public items: Array<any> = [];

  constructor(private http: KlaHttpService) { }

  ngOnInit() {
    this.draw();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.draw();
  }

  draw() {
    this.items = [];
    if (!this.config) {
      this.config = <MultiImageChartConfigurations> {};
    }
    if (this.config.items) {
      this.totalValue = 0;
      this.config.items.forEach((item: MultiImageItem) => {
        this.totalValue += item.value;
      });
      let sum = 0;
      this.config.items.forEach((item) => {
        const percentage = item.value / this.totalValue;
        const width = this.config.width * percentage;
        const height = this.config.height * percentage;
        const imageConfig = {
          id: item.image ?  item.image.id : '',
          width: width < 70 ? 70 : width,
          height: undefined,
          crop_config: item.image ? item.image.crop_config : {}
        };
        this.items.push({
          ...item,
          image: item.image ? this.http.getCroppedImagePath(imageConfig) : '',
          width: width,
          height: height,
        });
        sum += width;
      });
    }
  }
}
